"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Subtitle2Stronger", {
    enumerable: true,
    get: function() {
        return Subtitle2Stronger;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useSubtitle2Strongerstyles = require("./useSubtitle2Stronger.styles");
const Subtitle2Stronger = (0, _createPreset.createPreset)({
    useStyles: _useSubtitle2Strongerstyles.useSubtitle2StrongerStyles,
    className: _useSubtitle2Strongerstyles.subtitle2StrongerClassNames.root,
    displayName: 'Subtitle2Stronger'
});
